import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { fetchMDData } from 'partner360/services/masterDealer/fetchMDData'

import { GET_MASTER_DEALER_DATA_BY_ID } from '../configs'
import { selectMasterDealerData } from '../selectors'

export const getMasterDealerDataById = createAsyncThunk(
  GET_MASTER_DEALER_DATA_BY_ID,
  async ({ partnerId, options }: IRequestByPartnerId) => fetchMDData({ partnerId, options }),
  {
    condition({ partnerId }, { getState }) {
      if (!partnerId) {
        return false
      }

      const state = getState()
      const masterDealerData = selectMasterDealerData(state)
      if (masterDealerData.base.status === RequestStatus.PENDING) {
        return false
      }

      return true
    },
  }
)
